import { createRoot } from 'react-dom/client';

import AppProvider from '@sayyesschool/frontend/components/app-provider';
import { newTheme } from '@sayyesschool/frontend/theme';

import App from './app';
import store from './store';

import './index.scss';

createRoot(document.getElementById('root')).render(
    <AppProvider
        store={store}
        theme={newTheme}
    >
        <App />
    </AppProvider>
);